module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/admin/admin-customers/admin-customers.component.scss
// module id = ./src/app/components/admin/admin-customers/admin-customers.component.scss
// module chunks = main